import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import {
  DropdownWrapper,
  DropdownContainer,
  DropdownChevron,
  DropdownOptions,
  DropdownOption,
  DropdownInput,
} from "./MultiSelectDropdownStyled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faCheck } from "@fortawesome/free-solid-svg-icons";

interface Props {
  options: Array<any>;
  dropwdownLabel: string;
  allOptionsLabel: string;
  keyToShow: string;
  keyToReturn: string;
  onChange: (value: any) => void;
}

const Dropdown = forwardRef(
  (
    {
      options,
      onChange,
      dropwdownLabel,
      allOptionsLabel,
      keyToShow,
      keyToReturn,
    }: Props,
    Ref: any
  ) => {
    const [dropdownState, setDropdownState] = useState(false);
    const [currentValue, setCurrentValue] = useState<any>([]);
    const [shownOptions, setShownOptions] = useState(options);
    const [inputValue, setInputValue] = useState<string>("");
    

    useImperativeHandle(Ref, () => ({}));

    const setCurrentValueFunction = (value: any) => {
       
      if (currentValue.includes(value)) {
        setCurrentValue([...currentValue.filter((e: any) => e !== value)]);
      } else {
        setCurrentValue([...currentValue, value]);
      }
    };



    const setShownOptionsFunction = (value: any) => {
      const lowercasedValue = value.toLowerCase();
      setInputValue(lowercasedValue);
      if (value.length > 0) {
        const filteredList = options.filter(item =>
          item.domain.includes(lowercasedValue)
        );
        setShownOptions(filteredList);
      } else {
        setShownOptions(options); 
     
      }
      
    };

    useEffect(() => {
    
      onChange && onChange(currentValue);
    }, [currentValue]);


    useEffect(() => {
    
      if(!dropdownState){
        setShownOptions(options); 
      }
      
    }, [dropdownState]);

    useEffect(() => {
      if(options.length === 1){
        setCurrentValue([options[0][keyToReturn]]);
      }
      if (options.length >= 1 && inputValue.length == 0){
        setShownOptions(options);
      }
    }, [options]);

    return (
      <DropdownWrapper id='MultiSelectDropdownId'>
        <DropdownContainer onClick={() => setDropdownState(!dropdownState)}>
          <DropdownChevron id="Dropdown-chevron">
            <FontAwesomeIcon
              icon={dropdownState ? faChevronUp : faChevronDown}
            />
          </DropdownChevron>
          <input value={dropwdownLabel} disabled={true} />
        </DropdownContainer>
        {dropdownState && (
          <>
          
          
          <DropdownOptions>
          <DropdownInput>
            <input
            style={{ border: "none", width: "100%", padding: "0", outline: "none" }}          
            onChange={(e) => setShownOptionsFunction(e.target.value)}
            placeholder="Search for a subdomain..." 
          />
          </DropdownInput>
          
            {shownOptions.length > 1 && <DropdownOption
              key={"optionLabel"}
              onClick={() => setCurrentValue([])}
            >
              {allOptionsLabel} { currentValue.length === 0 && <FontAwesomeIcon icon={faCheck} />}
            </DropdownOption>}
            {shownOptions.map((option: any, index: any) => (
              <DropdownOption
                key={option[keyToReturn] + "option" + index}
                onClick={() => options.length > 1 && setCurrentValueFunction(option[keyToReturn])}
              >
                {option[keyToShow]} {  currentValue.includes(option[keyToReturn]) && <FontAwesomeIcon icon={faCheck} />}
              </DropdownOption>
            ))}
          </DropdownOptions>
          </>
        )}
      </DropdownWrapper>
      
    );
  }
);
export default Dropdown;